import { InmateFilters } from '@reliance/types/filters/InmateFilters';
import { Inmate } from '@reliance/types/models/Inmate';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';

export const useInmates = (filters?: InmateFilters) => {
  return useAsync(
    async () => {
      return await api.get<PaginatedResponse<Inmate>>('/inmate', { params: filters })
        .then(response => response.data);
    },
    [filters]
  );
};

export const useInmateById = (inmateId: number) => {
  return useAsync<Inmate>(
    async () => await api.get<Inmate>(`/inmate/by-id/${inmateId}?includeDisabled=true`)
      .then(response => response.data),
    [inmateId]
  );
};

export const useInmatesByFacilityId = (facilityId: number) => {
  return useAsync<PaginatedResponse<Inmate>>(
    async () => await api.get<PaginatedResponse<Inmate>>(`/inmate?facilityId=${facilityId}&perPage=5000`)
      .then(response => response.data),
    [facilityId]
  );
};